// extracted by mini-css-extract-plugin
export default {"navExtenedSublist":"HeaderNavExtendedSublist_navExtenedSublist__E9QyW"};